module.exports = __webpack_public_path__ + "img/20190720121859451.2483e19c.png";